module.exports = __webpack_public_path__ + "img/type.2b3cc6c4.png";